import {DateTime} from 'luxon';
import {Collection} from '@src/types/configurations';

export type CollectionDateTimeRange = {
  dateTimeFrom: DateTime | null;
  dateTimeTo: DateTime | null;
};

export type CollectionDateTimeRangeWithDefault = Required<{
  [K in keyof CollectionDateTimeRange]: NonNullable<CollectionDateTimeRange[K]>;
}>;

export const parseDateTimeFromCollection = (
  collection: Collection,
): CollectionDateTimeRange => {
  const [dateTimeFrom, dateTimeTo] =
    collection?.extent?.temporal?.interval?.[0] || [];

  return {
    dateTimeFrom: dateTimeFrom ? DateTime.fromISO(dateTimeFrom) : null,
    dateTimeTo: dateTimeTo ? DateTime.fromISO(dateTimeTo) : null,
  };
};

export const parseDateTimeFromCollectionWithDefaults = (
  collection: Collection,
): CollectionDateTimeRangeWithDefault => {
  const {dateTimeFrom, dateTimeTo} = parseDateTimeFromCollection(collection);

  const effectiveTo = dateTimeTo ?? DateTime.now();
  const effectiveFrom = dateTimeFrom ?? effectiveTo.minus({months: 1});

  return {
    dateTimeFrom: effectiveFrom,
    dateTimeTo: effectiveTo,
  };
};
